import React from 'react';
import styled from 'styled-components';

export default function Header() {
  return (
    <Container>
      <h3>אפשרויות נגישות</h3>
    </Container>
  );
}

const Container = styled.div`
  background-color: purple;
  h3 {
    color: white;
    padding: 20px 30px;
    margin: 0rem;
    text-align: center;
  }
`;
